import { get, patch } from 'utils/api';

export const getDealerEntitlements = (data) => {
  return get(`/dealer-entitlements`, data);
};

export const getDealerEntitlementById = (id) => {
  return get(`/dealer-entitlements/${id}`);
};

export const getDealerCreditTransactions = (data) => {
  return get(`/dealer-credit-transactions`, data);
};

export const getDealers = (data) => {
  return get(`/dealers`, data);
};

export const getDealerById = (id) => {
  return get(`/dealers/${id}`);
};

export const getDealerBranches = (id) => {
  return get(`/dealers/${id}/branches`);
};

export const updateDealer = (data) => {
  const id = data.id;
  delete data['id'];
  return patch(`/dealers/${id}`, data);
};

export const dealerEntitlement = {
  getDealers,
  getDealerById,
  getDealerBranches,
  updateDealer,
  getDealerCreditTransactions,
  getDealerEntitlements,
  getDealerEntitlementById,
};
